
































import Vue from 'vue';
import {mapActions} from 'vuex';
import { Quest } from '@/interfaces';
import { Rarity, QuestTemplateType } from '@/enums/Quest';
import QuestsList from './QuestsList.vue';

interface StoreMappedActions {
  getQuestTemplates(payload: { tier: number }): Promise<Quest[]>;

  getQuestDeadline(payload: { questID: number }): Promise<number>;

  getQuestSupply(payload: { questID: number }): Promise<number>;
}

interface Data {
  tiers: Rarity[];
  questTemplates: Quest[];
  templatesTier?: Rarity;
  isLoading: boolean;
  questTemplateType: QuestTemplateType;
}

export default Vue.extend({
  components: {QuestsList},

  data() {
    return {
      tiers: [Rarity.COMMON, Rarity.UNCOMMON, Rarity.RARE, Rarity.EPIC, Rarity.LEGENDARY],
      questTemplates: [],
      templatesTier: undefined,
      QuestTemplateType,
      questTemplateType: QuestTemplateType.WALLET,
      isLoading: false,
      Rarity,
    } as Data;
  },
  computed: {
    questTemplateTier(): number | undefined {
      if(this.templatesTier === undefined) {
        return undefined;
      }
      if(this.questTemplateType === QuestTemplateType.PROMO) {
        return this.templatesTier + 10;
      }
      else if(this.questTemplateType === QuestTemplateType.PICKABLE) {
        return this.templatesTier + 20;
      }
      else if(this.questTemplateType === QuestTemplateType.WALLET) {
        return this.templatesTier + 30;
      }
      else if(this.questTemplateType === QuestTemplateType.QUEST) {
        return this.templatesTier;
      }
      return this.templatesTier;
    }
  },
  methods: {
    ...mapActions([
      'getQuestTemplates',
      'getQuestDeadline',
      'getQuestSupply',
    ]) as StoreMappedActions,

    async refreshQuestTemplates() {
      if (!this.templatesTier|| !this.questTemplateTier) return;
      try {
        this.isLoading = true;
        this.questTemplates = await this.getQuestTemplates({tier: this.questTemplateTier});
        for (const quest of this.questTemplates) {
          quest.deadline = +await this.getQuestDeadline({questID: quest.id});
          quest.supply = +await this.getQuestSupply({questID: quest.id});
        }
      } finally {
        this.isLoading = false;
      }
    },
  },
  async mounted() {
    await this.refreshQuestTemplates();
    this.$root.$on('refresh-quest-templates', async () => {
      await this.refreshQuestTemplates();
    });
  }
});
